import React from "react";


import {
    Col
} from "react-bootstrap";


import {
    SvgIconComponent
} from "@Components/Elements";


import IconCheckboxCheckedSmGreen from "./@Icons/icon-checkbox_checked-sm-green.svg";
import IconCheckboxCheckedSmGrey from "./@Icons/icon-checkbox_checked-sm-grey.svg";
import IconCheckboxUncheckedSmGrey from "./@Icons/icon-checkbox_unchecked-sm-grey.svg";

import IconInfoRoundXsBlue from "./@Icons/icon-info_round-xs-blue.svg";


import "./index.scss";


interface CheckboxFieldComponentProps {
    checkboxLabel: string;
    checkboxCheckedStatus?: boolean;
    checkboxCheckedStatusHandler?: () => void;
    checkboxRequiredStatus?: boolean;
    checkboxDisabledStatus?: boolean;
    checkboxFieldCssClass?: string;
}


export const CheckboxFieldComponent:React.FC<CheckboxFieldComponentProps> = ({
    checkboxLabel,
    checkboxCheckedStatus = false, checkboxCheckedStatusHandler,
    checkboxRequiredStatus = false, checkboxDisabledStatus = false,
    checkboxFieldCssClass
}) => {


    const checkboxFieldCssClasses = [
        'checkbox-field-component'
    ];

    let checkboxFieldIcon;


    if (checkboxCheckedStatus) {
        checkboxFieldCssClasses.push('checkbox-field-component--field-checked');
        if (checkboxDisabledStatus) {
            checkboxFieldIcon = IconCheckboxCheckedSmGrey;
            checkboxFieldCssClasses.push('checkbox-field-component--field-disabled');
        } else {
            checkboxFieldIcon = IconCheckboxCheckedSmGreen;
        }
    } else {
        checkboxFieldIcon = IconCheckboxUncheckedSmGrey;
    }


    if (checkboxFieldCssClass) {
        checkboxFieldCssClasses.push(checkboxFieldCssClass);
    }


    return (
        <Col xs={12} className={checkboxFieldCssClasses.join(' ')}>
            <SvgIconComponent
                iconSource={checkboxFieldIcon}
                className={checkboxFieldCssClasses.map(cssClass => `${cssClass}__checkbox-field`).join(' ')}
                onClick={checkboxCheckedStatusHandler}
            />
            <span
                className={checkboxFieldCssClasses.map(cssClass => `${cssClass}__checkbox-label`).join(' ')}
                onClick={!checkboxDisabledStatus ? checkboxCheckedStatusHandler : undefined}
            >
                {checkboxLabel}
                {checkboxRequiredStatus && <span className={'checkbox-field-component__checkbox-label__label-required-status'}>*</span>}
            </span>
            {/*<span className={'checkbox-field-component__checkbox-information'}>*/}
            {/*    <SvgIconComponent iconSource={IconInfoRoundXsBlue} className={'checkbox-field-component__checkbox-information__information-icon'} />*/}
            {/*    <span className={'checkbox-information-tooltip'}>*/}
            {/*        We’ll send the request using the email address you provided at login.*/}
            {/*    </span>*/}
            {/*</span>*/}
        </Col>
    )

};


export default CheckboxFieldComponent;
